export default __webpack_public_path__ + "static/media/profileImg.e857f458.jpg";